export enum EAccessType {   
    Invariant, 
    Add,
    Edit
}